
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 19H2.679c-.908 0-1.643-.895-1.643-2V3c0-1.105.735-2 1.643-2h10.678C14.265 1 15 1.895 15 3v8.5M5.75 6.25h5.5M5.75 10.25h2.5","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M11.838 18.343l.15.328c.09.2.294.329.518.329a.568.568 0 00.518-.329l.15-.328a.613.613 0 01.257-.278.637.637 0 01.377-.078l.366.038a.571.571 0 00.551-.274.541.541 0 00-.032-.602l-.217-.29a.597.597 0 010-.716l.218-.291a.541.541 0 00.032-.602.572.572 0 00-.55-.274l-.367.038a.637.637 0 01-.377-.078.612.612 0 01-.257-.279l-.15-.328a.568.568 0 00-.52-.329.568.568 0 00-.518.329l-.15.328a.612.612 0 01-.256.28.637.637 0 01-.377.077l-.368-.038a.572.572 0 00-.55.274c-.113.19-.1.425.032.602l.217.29a.597.597 0 010 .715l-.217.291a.542.542 0 00-.033.602c.113.19.329.297.551.274l.367-.038a.637.637 0 01.377.078.612.612 0 01.258.279z","stroke":"#D07D01","stroke-width":"1.25"}})])
          )
        }
      }
    